import React, { useState } from "react";
import API_URL from "../../config";
import API_BASE_URL from "../../utils/api";

const Tooltip = ({ keyword, url = "", staticData = null }) => {
  const [data, setData] = useState(staticData || null);
  const [isHovered, setIsHovered] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    if (staticData || !url || data || loading) return;
    setLoading(true);

    try {
      const response = await fetch(
        `${API_BASE_URL}/fetch-data?url=${encodeURIComponent(url)}`
      );
      const result = await response.json();

      setData(result);
    } catch (error) {
      console.error("Error fetching preview data:", error);
    } finally {
      setLoading(false);
    }
  };

  const isStatic = Boolean(staticData);

  return (
    <span
      onMouseEnter={() => {
        setIsHovered(true);
        fetchData();
      }}
      onMouseLeave={() => {
        setTimeout(() => {
          if (!loading) setIsHovered(false);
        }, 300);
      }}
      style={{
        color: "#1a73e8",
        textDecoration: "none",
        cursor: "pointer",
        fontWeight: "500",
        position: "relative",
        padding: "",
        borderRadius: "4px",
        transition: "background 0.2s ease-in-out",
        backgroundColor: isHovered ? "rgba(26,115,232,0.1)" : "transparent",
      }}
    >
      {isStatic || !url ? (
        <span>{keyword}</span>
      ) : (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "inherit", textDecoration: "none" }}
        >
          {" "}
          {keyword}{" "}
        </a>
      )}

      {isHovered && data && (
        <div
          style={{
            position: "absolute",
            top: "1.5rem",

            left: "0rem",
            background: "white",
            border: "1px solid #dadce0",
            padding: "12px",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.15)",
            width: "250px",
            fontSize: "13px",
            lineHeight: "1.4",
            zIndex: 1000,
            borderRadius: "8px",
            transition: "opacity 0.2s ease-in-out",
            display: "flex",
            flexDirection: "column",
            gap: "6px",
          }}
        >
          {loading && (
            <p
              style={{
                fontSize: "12px",
                textAlign: "center",
                color: "#5f6368",
              }}
            >
              Loading...
            </p>
          )}
          {data && (
            <>
              {data.image && (
                <>
                  <img
                    src={data.image}
                    alt=""
                    style={{
                      width: "100%",
                      borderRadius: "4px",
                      objectFit: "cover",
                    }}
                  />
                  {data.imageSource && (
                    <a
                      href={data.imageSource.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        fontSize: "11px",
                        color: "#5f6368",
                        textDecoration: "none",
                        fontStyle: "italic",
                        marginTop: "2px",
                      }}
                    >
                      Image Source:{data.imageSource.name}
                    </a>
                  )}
                </>
              )}
              <p
                style={{
                  whiteSpace: "pre-wrap",
                  margin: " 0",
                  fontSize: "13px",
                  color: "#202124",
                  fontWeight: "400",
                }}
              >
                {data.content}
              </p>
              {data.sourceUrl && data.sourceName && (
                <a
                  href={data.sourceUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    fontSize: "12px",
                    color: "#1a73e8",
                    textDecoration: "none",
                    fontWeight: "500",
                    display: "block",
                    marginTop: "4px",
                  }}
                >
                  Source: {data.sourceName}
                </a>
              )}
            </>
          )}
        </div>
      )}
    </span>
  );
};

export default Tooltip;
